import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'adc-pagination',
  templateUrl: './adc-pagination.component.html',
  styleUrls: ['./adc-pagination.component.scss'],
  standalone: false
})
export class AdcPaginationComponent {
  @Input() totalItems: number = 0;
  @Input() itemsPerPage: number = 5;
  @Input() itemsPerPageArr: any;
  @Output() pageChange = new EventEmitter<number>();
  @Output() itemsPerPageChange = new EventEmitter<number>();

  public currentPage: number = 1;
  public itemsPerPageOpen: boolean = false;

  ngOnInit() {
    this.updatePagination();
  }

  ngOnChanges() {
    this.updatePagination();
  }

  private updatePagination() {
    this.pageChange.emit(this.currentPage);
  }

  public previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageChange.emit(this.currentPage);
    }
  }

  public nextPage() {
    if (this.currentPage < this.calculateTotalPages()) {
      this.currentPage++;
      console.log(this.currentPage)
      this.pageChange.emit(this.currentPage);
    }
  }

  public firstPage() {
    this.currentPage = 1;
    this.pageChange.emit(1);
  }

  public lastPage() {
    this.currentPage = this.calculateTotalPages();
    this.pageChange.emit(this.calculateTotalPages());
  }

  public openItemsPerPage() {
    this.itemsPerPageOpen = !this.itemsPerPageOpen;
  }

  public itemsPerPageVal(itemsPerPage: number) {
    this.itemsPerPage = itemsPerPage;
    this.itemsPerPageOpen = false;
    this.currentPage = 1; // Reset to the first page whenever items per page change
    this.updatePagination();
    this.itemsPerPageChange.emit(this.itemsPerPage);
  }

  public goToPage(page: number) {
    if (page >= 1 && page <= this.calculateTotalPages()) {
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
    }
  }

  calculateTotalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  getStartIndex(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getEndIndex(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }
}
